import { parsePlaywrightSignupIdentity } from '@vrplatform/ui-common';

const FIXED_PLAYWRIGHT_USER_EMAILS = new Set([
  'lars+e2e@vrplatform.app',
  'lars+e2e-gl@vrplatform.app',
  'e2e-sign-up-legacy@vrp.rocks',
  'e2e-sign-up@vrp.rocks',
  'e2e-sign-up-partner@vrp.rocks',
  'e2e-invite-owner@vrp.rocks',
  'e2e-invite-owner-legacy@vrp.rocks',
  'e2e-invite-member@vrp.rocks',
]);

const DYNAMIC_INVITE_BASE_RECIPIENTS = new Set([
  'e2e-invite-owner@vrp.rocks',
  'e2e-invite-owner-legacy@vrp.rocks',
  'e2e-invite-member@vrp.rocks',
]);

const INVITE_ALIAS_PATTERN =
  /^([^+@]+)\+([a-z0-9](?:[a-z0-9._-]*[a-z0-9])?)@([^@]+)$/;

export const isPlaywrightUserEmail = (
  userEmail: string | null | undefined
): boolean => {
  if (!userEmail) return false;

  const normalizedEmail = userEmail.trim().toLowerCase();
  if (FIXED_PLAYWRIGHT_USER_EMAILS.has(normalizedEmail)) return true;
  if (parsePlaywrightSignupIdentity(normalizedEmail).status === 'valid')
    return true;

  const match = normalizedEmail.match(INVITE_ALIAS_PATTERN);
  const baseLocalPart = match?.[1];
  const domain = match?.[3];
  if (!baseLocalPart || !domain) return false;

  return DYNAMIC_INVITE_BASE_RECIPIENTS.has(`${baseLocalPart}@${domain}`);
};
